<template>
    <div class="container">
        <div class="tab_wrapper">
          <CreatePlusTemplateListTabs 
            v-bind:categoryID="categoryid"
            v-bind:subCategoryID="subcategoryid" />
        </div>
        <div v-if="this.showMessage">
          <p class="info_small">
            <!-- このコンテンツはスマホアプリ「Epson Creative Print」では印刷出来ません。PCアプリ「Epson Photo＋」をご利用ください。 -->
            <span class="glyphicon glyphicon-info-sign"></span>
            <CreateplusMessage fcontId="0" flinkId="1" msgkey="28" />
          </p>
        </div>
        <template v-if="createplusTemplatesStatus">
            <create-plus-template-list-tiles 
              :createplusTemplates="initialDisplayedTemplates" 
              :categoryid="this.categoryid" 
              :subcategoryid="this.subcategoryid" />
        </template>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CreatePlusTemplateListTabs from "./CreatePlusTemplateListTabs";
import CreatePlusTemplateListTiles from "./CreatePlusTemplateListTiles";
import CreateplusMessage from "./CreateplusMessage";
export default {
  name: "CreatePlusTemplateList",
  props: {
    categoryid: String,
    subcategoryid: String,
  },
  components: {
    CreatePlusTemplateListTabs,
    CreatePlusTemplateListTiles,
    CreateplusMessage,
  },
  computed: {
    ...mapState('createplusTemplates', ['createplusCategories', 'createplusCategoriesStatus', 'createplusTemplates', 'createplusTemplatesStatus']),
    ...mapState("createplusMessages", ["createplusMessages"]),
    ...mapGetters(["isBuiltInApp"]),

    // 初期表示するテンプレート一覧
    initialDisplayedTemplates: function() {
      const category = this.createplusCategories.find(
        (category) => category.categoryID === this.categoryid);
      const subcategory = category.subCategories.find(
        (subcategory) => subcategory.subCategoryID === this.subcategoryid);
      let templates = this.createplusTemplates.filter(template => template.subCategoryNumber === subcategory.subCategoryNumber);
      templates = Array.from(templates).sort((a, b) =>{
        if (a.templatePriority === undefined || b.templatePriority === undefined ){
          return 0
        }
        if (a.templatePriority < b.templatePriority) {
          return -1
        } else {
          return 1
        }
      })
      return templates
    },
    showMessage: function() {
      if (this.subcategoryid == 'WD01' && !this.isBuiltInApp) {
        return true
      }
      return false
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.fade-enter-active {
  transition: opacity 0.6s;
}
.fade-enter {
  opacity: 0;
}
</style>